export enum Tenant {
  // Unknown = "--Unknown--",
  None = "--None--",
  Homeslice = "Homeslice",
}
